module.exports = __webpack_public_path__ + "img/business_pic2.fa11e26f.png";